import { TabConfigType } from '@common';
import { PersonDetailsEndKey } from 'src/i18next';

export type PersonTab = TabConfigType<'general' | 'tourrep' | 'settlements'> & {
  labelKey: PersonDetailsEndKey<'TABS'>;
};

export const tabs: PersonTab[] = [
  {
    labelKey: 'OVERVIEW',
    value: 'general',
    requiredPermissions: [],
  },
  {
    labelKey: 'TOUR_REP_SELF_PROMOTE',
    value: 'tourrep',
    requiredPermissions: [
      {
        permission: 'PROJECTS_TOURREP_CALENDAR',
        action: 'WRITE',
      },
      {
        permission: 'ADDRESSBOOK_TOURREP_SCHEDULE',
        action: 'READ',
      },
    ],
  },
  {
    labelKey: 'SETTLEMENTS',
    value: 'settlements',
    requiredPermissions: [
      {
        permission: 'FINANCE',
        action: 'READ',
      },
    ],
  },
];
